import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function AboutSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  const stats = [{
    value: '5000+',
    label: '活跃会员'
  }, {
    value: '200+',
    label: '认证伴游'
  }, {
    value: '24/7',
    label: '在线服务'
  }, {
    value: '100%',
    label: '隐私保护'
  }];
  return <section className="py-24 px-4 relative z-10 bg-dark-bg" data-id="element-10">
      <div className="max-w-5xl mx-auto" data-id="element-11">
        <motion.div className="text-center mb-16" initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} data-id="element-12">
          <motion.h2 variants={itemVariants} className="text-3xl md:text-5xl font-bold mb-4 text-white" data-id="element-13">
            关于<span className="text-pink-primary neon-glow" data-id="element-14">芽笼777</span>
          </motion.h2>
          <motion.div variants={itemVariants} className="w-24 h-1 bg-pink-primary mx-auto rounded-full mb-8" data-id="element-15"></motion.div>
        </motion.div>
        <motion.div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-20" initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} data-id="element-16">
          <motion.div variants={itemVariants} className="space-y-6 text-gray-300 text-lg leading-relaxed" data-id="element-17">
            <p data-id="element-18">
              芽笼777是新加坡最受信赖的高端伴游信息平台，专注于为客户提供安全、私密、优质的伴游服务资讯。我们深耕新加坡本地市场多年，拥有丰富的行业经验和广泛的服务网络。
            </p>
            <p data-id="element-19">
              新加坡作为亚洲最国际化的都市之一，芽笼（Geylang）地区历来是夜生活与娱乐服务的核心区域。芽笼777立足于此，为本地及来访的国际客户搭建一座连接优质伴游服务的桥梁。
            </p>
            <p data-id="element-20">
              我们的平台汇聚来自中国、越南、泰国、马来西亚、日本、韩国等亚洲各国的优质伴游，每一位均经过严格筛选与认证，确保为您提供最真实、最满意的体验。
            </p>
          </motion.div>
          <motion.div variants={itemVariants} className="relative" data-id="element-21">
            <div className="absolute inset-0 bg-pink-primary opacity-20 blur-[60px] rounded-full" data-id="element-22"></div>
            <div className="grid grid-cols-2 gap-4 relative z-10" data-id="element-23">
              {stats.map((stat, index) => <div key={index} className="bg-dark-card p-6 rounded-2xl neon-border text-center" data-id="element-24">
                  <div className="text-3xl md:text-4xl font-black text-pink-primary mb-2" data-id="element-25">
                    {stat.value}
                  </div>
                  <div className="text-sm text-gray-400 font-medium" data-id="element-26">
                    {stat.label}
                  </div>
                </div>)}
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}